import { render, staticRenderFns } from "./HighlightTypeItem.vue?vue&type=template&id=0d30b3a3&"
import script from "./HighlightTypeItem.vue?vue&type=script&lang=js&"
export * from "./HighlightTypeItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports